export default __webpack_public_path__ + "static/media/north-elevation.e25c5e17.png";